import AnswerValidityChren from "@/components/AnswerValidityChren";
import AnswerValidityChrenClick from "@/components/AnswerValidityChrenClick";
import CarouselComponent from "@/components/CarouselComponent";
import { contexData } from "@/store";
import { Checkbox, Input, Table } from "antd";
import { cloneDeep, isEqual } from "lodash";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useStateWithCallbackLazy } from "use-state-with-callback";
import { InputWapper } from "../../utils/helper";
import "./less/Checkbox.less";
import { language } from "@/utils/language"; 

const isMobile = /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);

function parseExclusive(question, answer, exclusives) {
  // console.log('2222',data.data.questions[0]);
  const excludeCode = [];
  function matchQuestionPattern(pattern, code) {
    if (!pattern || !code) return false;
    const p = String(pattern).trim();
    // wildcard like Q1_*
    if (p.includes("*")) {
      const prefix = p.split("*")[0];
      return String(code).indexOf(prefix) === 0;
    }
    // bracket list like Q1_[1,2,3]
    const m = p.match(/(.+?)\[(.+)\]/);
    if (m) {
      const prefix = m[1];
      const items = m[2].split(",").map((s) => s.trim());
      return items.some((it) => String(code) === prefix + it);
    }
    return p === String(code);
  }

  exclusives.filter((ex) => {
    try {
      if (matchQuestionPattern(ex[0], question.code)) {
        // 是当前题目（支持通配符和下标集合）
        if (+ex[1] === answer.codeValue) {
          // 当前选项排斥其他
          if (ex[3] === "0") {
            // 其他所有
            const { options } = question;
            options
              .filter((o) => o.codeValue !== +ex[1])
              .map((o) => excludeCode.push(o.codeValue));
          } else {
            // 其他某些
            String(ex[3] || "").split(",").map((c) => excludeCode.push(+c));
          }
        } else if (
          String(ex[3] || "").split(",").includes(String(answer.codeValue)) ||
          ex[3] === "0"
        ) {
          // 其他排斥当前选项
          excludeCode.push(+ex[1]);
        }
      }
    } catch (e) {
      // ignore malformed exclusive entry
    }
    return 0;
  });
  return excludeCode;
}

function getColumns(
  {
    arrary,
    handleCellClick,
    handleCellInput,
    checkState,
    exclusives,
    direction,
    headLineShow,
    code2AnswerId,
    firstColumnWidth,
  },
  dispatch,
  infoContex
) {
  const empty = {
    title: "",
    dataIndex: "code",
    align: "center",
    width: firstColumnWidth + "%",
    className: "",

    render: (_, row) => {
      if (row.isTitle) {
        return "";
      }
      if (row.moduleOption === 1) {
        return {
          children: (
            <div className="lebel-cell">
              <div
                dangerouslySetInnerHTML={{
                  __html: row.description
                    .replace(/<p><\/p>/g, "<br />")
                    .replace(/\n\n/g, "<br />")
                    .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                }}
              ></div>

            </div>
          ),
          props: { colSpan: arrary.length + 1 },
        };
      }
      if (row.moduleOption === 2) return <></>;
      return (
        <AnswerValidityChren info={row}>
          <div
            style={{
              color:
                infoContex.preferences?.[
                !direction ? "sonColour" : "optionColour"
                ],
              width: '100%'
            }}
            dangerouslySetInnerHTML={{
              __html: row.description
                .replace(/<p><\/p>/g, "<br />")
                .replace(/\n\n/g, "<br />")
                .replace(/\s{2}/g, "&nbsp;&nbsp;"),
            }}
          ></div>

        </AnswerValidityChren>
      );
    },
  };

  const columns = arrary
    .filter(({ hide }) => !hide)
    .map((col, index) => {
      const len = arrary.filter(({ hide }) => !hide).length;
      const columnWidth = ((100 - firstColumnWidth) / len).toFixed(2) + "%";
      return {
        title: (
          <div
            id={col.id}
            style={{
              background: col.id == infoContex.highlight ? " #1890ff" : "",
              color:
                infoContex.preferences?.[
                direction ? "sonColour" : "optionColour"
                ],
            }}
            dangerouslySetInnerHTML={{
              __html: col.description
                .replace(/<p><\/p>/g, "<br />")
                .replace(/\n\n/g, "<br />")
                .replace(/\s{2}/g, "&nbsp;&nbsp;"),
            }}
          ></div>
        ),
        dataIndex: col.code,
        align: "center",
        className: `table-cell  ${col.moduleOption ? "table-cell-disabled" : ""}`,
        width: columnWidth,
        render: getRenderFunc(col, index),
      };
    });

  return [empty, ...columns];

  function getRenderFunc(col, index) {
    return direction
      ? (_, row, rowIndex) => {
        if (row.isTitle) {
          return (
            <div
              style={{
                border: col.id == infoContex.highlight ? "1px solid red" : "",
              }}
              dangerouslySetInnerHTML={{
                __html: col.description
                  .replace(/<p><\/p>/g, "<br />")
                  .replace(/\n\n/g, "<br />")
                  .replace(/\s{2}/g, "&nbsp;&nbsp;"),
              }}
            ></div>
          );
        }
        const questionId = col.id;
        const options = col.options.filter(
          ({ moduleOption }) => moduleOption !== 2
        );
        let optIndex = rowIndex;

        if (headLineShow && headLineShow > 0) {
          const mod = rowIndex % (headLineShow + 1);
          const div = parseInt(rowIndex / (headLineShow + 1));
          optIndex = (mod + div * headLineShow);
        }
        const answerId = options[optIndex]?.id;
        const excludeCode = parseExclusive(col, row, exclusives);
        if (row.moduleOption === 1)
          return { children: null, props: { colSpan: 0 } };
        const checked = checkState[`${questionId}_${answerId}`];
        let hide = excludeCode
          .map((code) => code2AnswerId(questionId, code))
          .some((answerId) => checkState[`${questionId}_${answerId}`]);
        hide = hide || (options[optIndex]?.hide);
        const fixed = options[optIndex]?.fixed || options[optIndex]?.disable;
        return (
          <div
            className="cell-div"
            onClick={
              col.moduleOption || hide || fixed
                ? () => { }
                : () => {
                  dispatch({ type: "highlight", data: { highlight: "" } });
                  handleCellClick(questionId, answerId, excludeCode, index);
                }
            }
          >
            {!hide && !col.moduleOption ? (
              <Checkbox checked={checked} disabled={fixed} />
            ) : (
              <label className="ant-checkbox-wrapper"></label>
            )}
            {checked && row.open ? (
              <div
                style={{
                  display: "flex",
                  padding: "6px",
                }}
              >
                <InputWapper unit={row.unit}>
                  <Input
                  placeholder={language().input_placeholder}
                    defaultValue={typeof checked === "string" ? checked : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onChange={(e) =>
                      handleCellInput(questionId, answerId, e.target.value)
                    }
                  />
                </InputWapper>
              </div>
            ) : (
              <></>
            )}
          </div>
        );
      }
      : (_, row, rowIndex) => {
        if (row.isTitle) {
          return (
            <div
              style={{
                border: col.id == infoContex.highlight ? "1px solid red" : "",
              }}
              dangerouslySetInnerHTML={{
                __html: col.description
                  .replace(/<p><\/p>/g, "<br />")
                  .replace(/\n\n/g, "<br />")
                  .replace(/\s{2}/g, "&nbsp;&nbsp;"),
              }}
            ></div>
          );
        }
        const questionId = row.id;
        const options = row.options;
        const answerId = options?.[index]?.id;
        const excludeCode = parseExclusive(row, col, exclusives);
        if (row.moduleOption === 1)
          return { children: null, props: { colSpan: 0 } };
        const checked = checkState[`${questionId}_${answerId}`];
        let hide = excludeCode
          .map((code) => code2AnswerId(questionId, code))
          .some((answerId) => checkState[`${questionId}_${answerId}`]);
        try {
          hide = hide || options[index].moduleOption === 1;
          hide = hide || options[index].hide;
        } catch (error) { }
        const fixed = options[index]?.fixed || options[index]?.disable;
        let optIndex = rowIndex;
        if (headLineShow) {
          const mod = rowIndex % (headLineShow + 1);
          const div = parseInt(rowIndex / (headLineShow + 1));
          optIndex = mod + div * headLineShow;
        }
        return (
          <AnswerValidityChrenClick
            colItem={row}
            className="cell-div"
            onClick={() =>
              !hide &&
              !fixed &&
              handleCellClick(questionId, answerId, excludeCode, optIndex)
            }
          >
            {!hide ? (
              <Checkbox checked={checked} disabled={fixed} />
            ) : (
              <label className="ant-checkbox-wrapper"></label>
            )}
            {checked && col.open ? (
              <div
                style={{
                  display: "flex",
                  padding: "6px",
                }}
              >
                <InputWapper unit={col.unit}>
                  <Input
                  placeholder={language().input_placeholder}
                    defaultValue={typeof checked === "string" ? checked : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onChange={(e) =>
                      handleCellInput(questionId, answerId, e.target.value)
                    }
                  />
                </InputWapper>
              </div>
            ) : (
              <></>
            )}
          </AnswerValidityChrenClick>
        );
      };
  }
}

function CheckboxMatrix({ answer, info, changeAnswer }) {
  const {
    childs,
    options,
    scripts,
    preferences: {
      childPrefer: {
        direction,
        optionForm,
        fadeOut,
        firstColumnWidth,
        headLineShow,
        pcH5Setting,
      },
    },
  } = info
  // ||data.data.questions[0];
  const [checkState, setCheckState] = useStateWithCallbackLazy({});
  const [questionNum, setQuestionNum] = useState(1);
  const inputRef = useRef({});
  const { infoContex, dispatch, isBack } = useContext(contexData); //解构得到属性

  // 改变state之后的回调函数
  const setStateCallback = useCallback(
    (currentState) => {
      const newAnswer = {};
      for (const [key, checked] of Object.entries(currentState)) {
        if (checked) {
          const [question, answer] = key.split("_");
          newAnswer[question] = newAnswer[question] || {};
          newAnswer[question][answer] = inputRef.current[key] || null;
          if (typeof checked === "string") {
            inputRef.current[key] = checked;
            newAnswer[question][answer] = checked;
          }
        }
      }
      if (!isEqual(newAnswer, answer)) {
        changeAnswer(newAnswer);
      }
    },
    [changeAnswer]
  );
  const [renderTime, setRenderTime] = useState(0);

  const [initailized, setInitailized] = useState(false);

  useEffect(() => {
    const defualtChecked = {};
    if (initailized) return;
    // 设置上次选中的答案
    const obj = answer[info.id] ? answer[info.id] : answer;
    for (const [qid, o] of Object.entries(obj)) {
      for (const [oid, v] of Object.entries(o)) {
        defualtChecked[`${qid}_${oid}`] = v?.text || true;
      }
    }
    // 这是一坨屎，但是有必要。
    if (Object.keys(obj).length === 0)
      if (renderTime < 10 && !isBack) {
        (childs || []).map((question) => {
          (question?.options || []).map((option) => {
            if (option.selected === 1) {
              defualtChecked[`${question.id}_${option.id}`] = true;
            }
            return undefined;
          });
          return undefined;
        });
        setRenderTime(renderTime + 1);
        setCheckState(defualtChecked);
      }
    setTimeout(() => {
      setCheckState(defualtChecked, setStateCallback);
      setInitailized(true);
    }, 10);
    // eslint-disable-next-line
  }, [answer]);

  useEffect(() => {
    setTimeout(() => {
      setRenderTime(10);
    }, 1000);
  }, []);

  // 互斥逻辑数组
  const exclusives = (scripts || [])
    .map((item) => {
      if (item.includes("EXCLUSIVE")) {
        const ex = item
          .replace("EXCLUSIVE", "")
          .replace("(", "[")
          .replace(")", "]");
        // eslint-disable-next-line
        return eval(ex);
      }
      return undefined;
    })
    .filter((n) => n);

  const code2AnswerId = (questionId, code) => {
    try {
      const { options } = childs.find(({ id }) => id === questionId);
      const { id } = options.find(({ codeValue }) => +code === codeValue);
      return id;
    } catch (error) {
      return undefined;
    }
  };

  /**
   * moduleOption
   * 0 正常
   * 1 独占一行
   * 2 隐藏
   */

  const [data1, setdata1] = useState([]);


  useEffect(() => {
    if (fadeOut == 1) {
      if (questionNum > 1) {
        let data = direction
          ? options.filter(({ moduleOption, hide }) => moduleOption !== 2 && !hide)
          : childs.filter(({ moduleOption, hide }) => moduleOption !== 2 && !hide);
        if (fadeOut == 1 && !direction) {
          data = data.slice(0, questionNum);
        }

        setdata1(data)
      }
    } else {
      if(questionNum==1){
        let data = direction
        ? options.filter(({ moduleOption, hide }) => moduleOption !== 2 && !hide)
        : childs.filter(({ moduleOption, hide }) => moduleOption !== 2 && !hide);
      if (fadeOut == 1 && !direction) {
        data = data.slice(0, questionNum);
      }

      // 隔行显示表头
      if (headLineShow > 0) {
        const len = data.length;

        let time = 0;
        for (let i = 1; i < len; i++) {
          if (!(i % +headLineShow)) {
            const [first] = data;
            const newObj = cloneDeep(first);
            newObj.isTitle = true;
            newObj.id = first.id + "--" + i
            newObj.description = first.description + "--" + i
            // newObj.id = Math.random().toString(16).substr(2);
            data.splice(i + time, 0, newObj);
            time++;
          }
        }
      }
      if (headLineShow == -1) {
        let len = 0;

        const oldData = cloneDeep(data);
        oldData.forEach((element, index) => {
          if (element.moduleOption == 1 && index != 0) {
            data.splice(index + len, 0, { ...element, moduleOption: 0, isTitle: true, id: element.id + '--' + index, });
            len++;
          }
        });
      } else if (headLineShow == -2) {
        const oldData = cloneDeep(data);
        let len = 0;
        oldData.forEach((element, index) => {
          if (element.moduleOption == 1) {
            data.splice(index + 1 + len, 0, { ...element, moduleOption: 0, isTitle: true, id: element.id + '--' + index });
            len++;
          }
        });
      }
      console.log('datadatadatadata123', data);
      setdata1(data)
      }

      
    }

  }, [questionNum])

  
  // 点击的一些操作，不要妄想改这个方法， 你不配
  const onCellClick = (
    questionId,
    answerId,
    excludeCode = [],
    questionIndex
  ) => {
    console.log(questionIndex, questionNum);
    if (direction) {
      if (questionIndex + 1 === questionNum) {
        const obj = childs[questionIndex + 1] || {};
        const step = obj.moduleOption ? 2 : 1;
        setQuestionNum(questionNum + step);
      }
    } else {
      if (headLineShow) {
        // 每隔几行显示表头
        if (questionIndex + 1 === questionNum) {
          let step = 1;
          const obj = childs[questionIndex + 1] || {};
          if (obj.moduleOption) step++;
          setQuestionNum(questionNum + step);
        }
      } else {
        if (questionIndex + 1 === questionNum) {
          const obj = childs[questionIndex + 1] || {};
          const step = obj.moduleOption ? 2 : 1;
          setQuestionNum(questionNum + step);
        }
      }
    }
    // 如果有互斥条件,要根据互斥条件来生成新的选中状态
    if (exclusives && exclusives.length) {
      const newCheckState = { ...checkState };
      const key = `${questionId}_${answerId}`;
      newCheckState[key] = !newCheckState[key];
      excludeCode.forEach((code) => {
        const answerId = code2AnswerId(questionId, code);
        const key = `${questionId}_${answerId}`;
        delete newCheckState[key];
      });
      setCheckState(newCheckState, setStateCallback);
    } else {
      const key = `${questionId}_${answerId}`;
      setCheckState(
        (prevState) => ({
          ...prevState,
          [key]: !prevState[key],
        }),
        setStateCallback
      );
    }
  };

  // 输入框输入时,直接改变答案里的值
  const onCellInput = (questionId, answerId, value) => {
    inputRef.current[`${questionId}_${answerId}`] = value;
    const newAnswer = {};
    for (const [key, checked] of Object.entries(checkState)) {
      if (checked) {
        const [question, answer] = key.split("_");
        newAnswer[question] = newAnswer[question] || {};
        newAnswer[question][answer] = inputRef.current[key] || null;
        if (question === questionId && answer === answerId) {
          newAnswer[question][answer] = value;
        }
      }
    }
    changeAnswer(newAnswer);
  };

  let column = direction
    ? childs.filter((o) => o.moduleOption !== 2)
    : options.filter((o) => o.moduleOption !== 2);

  if (fadeOut == 1 && direction) {
    column = column.slice(0, questionNum);
  }



  // ////////////////////
  const params = {
    arrary: column,
    handleCellClick: onCellClick,
    handleCellInput: onCellInput,
    checkState,
    exclusives,
    direction,
    code2AnswerId,
    headLineShow: +headLineShow,
    firstColumnWidth: firstColumnWidth || 13,
  };
  const columns = getColumns(params, dispatch, infoContex);
  const rowClassName = (record) => (record.isTitle ? "custom-head" : "");

  // 检查卡片题是否能用于当前客户端
  let cardOptionFormEnable = false;
  if (optionForm === 4) {
    const pcH5SettingValue = pcH5Setting ?? 0;
    cardOptionFormEnable = true;
    if (pcH5SettingValue === 1 && isMobile) {
      cardOptionFormEnable = false;
    }
    if (pcH5SettingValue === 2 && !isMobile) {
      cardOptionFormEnable = false;
    }
  }
  return (
    <>
      <CarouselComponent colData={data1} info={info}>
        {!cardOptionFormEnable ? ( // 是否是卡片题
          <>
            {/* <div style={{  border:'.5px solid #b2c1cc'}} ></div> */}
            <Table
              bordered
              rowKey="id"
              columns={columns}
              pagination={false}
              dataSource={data1}
              rowClassName={rowClassName}
            />
          </>


        ) : (
          data1.map((item) => {
            return (
              <Table
                bordered
                rowKey="id"
                columns={columns}
                pagination={false}
                dataSource={[item]}
                rowClassName={rowClassName}
              />
            );
          })
        )}
      </CarouselComponent>
    </>
  );
}

export default CheckboxMatrix;
